import {
    sentryAPIErrorV2, 
    protectedApiCallWithPromise,
    apiCallWithPromise,
    uam,
    funnelUpdate,
} from './module_common';

export class FetchError extends Error {
    constructor(response) {
        super(`HTTP error ${response.status}`);
        this.response = response;
    }
}

function setBooksFavouriteCall(data){
    const method = 'POST'
    const url = '/users/'+UIDg+'/favourites'
    return protectedApiCallWithPromise(method, url, data, false)
    .catch((err) => {
        const contextData = {
            apicalldata: {
                function: "setBooksFavourite",
                url: url,
                method: method,
                data: JSON.stringify(data),
                status: err.status,
                response: err.responseJSON,
            }
        }
        const error = new Error('protectedApiCallWithPromise error')
        error.name = 'setBooksFavourite fail'
        sentryAPIErrorV2(error, contextData)
    })
}

export function setBooksFavourite(books){
    const formatted = {
        'books': books
    }
    return setBooksFavouriteCall(formatted);
}

function setCategoriesFeedback(data){
    const method = 'POST'
    const url = '/users/'+UIDg+'/categories/feedback'
    return protectedApiCallWithPromise(method, url, data, false)
    .catch((err) => {
        const contextData = {
            apicalldata: {
                function: "setCategoriesFeedback",
                url: url,
                method: method,
                data: JSON.stringify(data),
                status: err.status,
                response: err.responseJSON,
            }
        }
        const error = new Error('protectedApiCallWithPromise error')
        error.name = 'setCategoriesFeedback fail'
        sentryAPIErrorV2(error, contextData)
    })
}

export function setCategoriesLike(dataArray){
    const formattedData = []
    dataArray.forEach(element => {
        const formatted = {
            'category_id': element.id,
            'liked': element.val ? 1 : 0
        }
        formattedData.push(formatted)
    });
    const data = {'data': formattedData}
    return setCategoriesFeedback(data)
}

function setSkillsFeedback(data){
    const method = 'POST'
    const url = '/favourites/skills?clean=true'
    return protectedApiCallWithPromise(method, url, data, false, false, 'ms-1')
    .catch((err) => {
        const contextData = {
            apicalldata:{
                function: "setSkillsFeedback",
                url: url,
                method: method,
                data: JSON.stringify(data),
                status: err.status,
                response: err.responseJSON,
            }
        }
        const error = new Error('protectedApiCallWithPromise error')
        error.name = 'setSkillsFeedback fail'
        sentryAPIErrorV2(error, contextData)
    })
}

export function setSkillsFavourite(skills){
    // implement funnel update after this call
    const formattedData = []
    skills.forEach(sk => {
        const formatted = {
            'skill_id': parseInt(sk),
        }
        formattedData.push(formatted)
    });
    const data = {'data': formattedData}
    return setSkillsFeedback(data)
}


export function skillAddFavourite(sid) {
    const method = 'POST'
    const url = '/favourites/skills/' + sid
    return protectedApiCallWithPromise(method, url, {}, false, false, 'ms-1')
    .then((resp) => {
        funnelUpdate("skill_liked")
        return resp
    })
    .catch((err) => {
        const contextData = {
            apicallData:{
                url: url,
                method: "skillAddFavourite",
                data: {},
                status: err.status,
                response: err.responseJSON,
            }
        }
        const error = new Error('protectedApiCallWithPromise error')
        error.name = 'skillAddFavourite fail'
        sentryAPIErrorV2(error, contextData);
    })
}

export function skillRemoveFavourite(sid) {
    const method = 'DELETE'
    const url = uam('/favourites/skills/'+sid+'/xxx')
    return protectedApiCallWithPromise(method, url, {}, false, false, 'ms-1')
    .catch((err) => {
        const contextData = {
            apicallData:{
                url: url,
                method: "skillRemoveFavourite",
                data: {},
                status: err.status,
                response: err.responseJSON,
            }
        }
        const error = new Error('protectedApiCallWithPromise error')
        error.name = 'skillRemoveFavourite fail'
        sentryAPIErrorV2(error, contextData);
    })
}

export function getMatchesSkill(bid){
    const method = 'POST'
    const url = '/matches/skills/by_books'
    const data = {'lang': LL, 'books': [bid]}
    return protectedApiCallWithPromise(method, url, data, true, false, 'ms-1')
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "getMatchesSkill",
                    url: url,
                    method: method,
                    data: JSON.stringify(data),
                    status: err.status,
                    response: err.responseJSON,
                }
            }
            const error = new Error('protectedApiCallWithPromise error')
            error.name = 'getMatchesSkill fail'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}

export function getSkills(ids){
    const method = 'POST'
    const url = '/searches/skills'
    const data = {ids: ids}
    return protectedApiCallWithPromise(method, url, data, true, false, 'ms-1')
        .then(resp => resp)
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "getSkills",
                    url: url,
                    method: method,
                    data: JSON.stringify(data),
                    status: err.status,
                    response: err.responseJSON,
                }
            }
            const error = new Error('protectedApiCallWithPromise error')
            error.name = 'getSkills fail'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}

export function getSkill(id){
    const method = 'GET'
    const url = '/skills/'+id
    return apiCallWithPromise(method, url, "", 'ms-1')
        .then(resp => resp)
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "getSkill",
                    url: url,
                    method: method,
                    status: err.status,
                    response: err.responseJSON,
                }
            }
            const error = new Error('protectedApiCallWithPromise error')
            error.name = 'getSkill fail'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}

export function getLightSkill(){
    const method = 'GET'
    const url = '/skills'
    return protectedApiCallWithPromise(method, url, "", true, false, 'ms-1')
        .then(resp => resp)
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "getLightSkill",
                    url: url,
                    method: method,
                    status: err.status,
                    response: err.responseJSON,
                    readystate: err.readyState,
                    responsetype: err.responseType,
                    statustext: err.statusText,
                    responseXML: err.responseXML,
                }
            }
            if (!err.status){
                contextData.apicalldata.status = "Maybe Network error, unreachable URL, request is interrupted"
                return;
            }
            const error = new Error('protectedApiCallWithPromise error', {cause: err})
            error.name = 'getLightSkill fail complete error'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}
// Get("/api/ms-1/game/user/skills/xps")
export function getSkillsXp(){
    const method = 'GET'
    const url = '/game/user/skills/xps'
    return protectedApiCallWithPromise(method, url, "", true, false, 'ms-1')
        .then(resp => resp)
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "getSkillXp",
                    url: url,
                    method: method,
                    status: err.status,
                    response: err.responseJSON,
                    readystate: err.readyState,
                    responsetype: err.responseType,
                    statustext: err.statusText,
                    responseXML: err.responseXML,
                }
            }
            if (!err.status){
                contextData.apicalldata.status = "Maybe Network error, unreachable URL, request is interrupted"
                return;
            }
            const error = new Error('protectedApiCallWithPromise error', {cause: err})
            error.name = 'getSkillXp fail complete error'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}

export function getSkillLevels(){
    const method = 'GET'
    const url = '/skill_levels'
    return protectedApiCallWithPromise(method, url, "", true, false, 'ms-1')
        .then(resp => resp)
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "getSkillLevels",
                    url: url,
                    method: method,
                    status: err.status,
                    response: err.responseJSON,
                    readystate: err.readyState,
                    responsetype: err.responseType,
                    statustext: err.statusText,
                    responseXML: err.responseXML,
                }
            }
            if (!err.status){
                contextData.apicalldata.status = "Maybe Network error, unreachable URL, request is interrupted"
                return;
            }
            const error = new Error('protectedApiCallWithPromise error', {cause: err})
            error.name = 'getSkillLevels fail complete error'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}

export function sendBookLike(bid, value){
    const method = 'POST'
    const url = '/users/'+UIDg+'/books/'+bid+'/feedback'
    const data = {"data": [{"key": "liked", "ival": value}]};
    return protectedApiCallWithPromise(method, url, data, true, false, '')
        .then(resp => resp)
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "sendBookLike",
                    url: url,
                    method: method,
                    data: JSON.stringify(data),
                    status: err.status,
                    response: err.responseJSON,
                }
            }
            const error = new Error('protectedApiCallWithPromise error')
            error.name = 'sendBookLike fail'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}

export function sendArticleLike(aid, value){
    const method = 'POST'
    const url = '/users/'+UIDg+'/articles/feedback'
    const data = {"data": [{"article_id": aid, "liked": value}]};
    return protectedApiCallWithPromise(method, url, data, true, false, '')
        .then(resp => {
            if (resp.data[0].err){
                const err = new Error()
                err.status = 200
                err.responseJSON = JSON.stringify(resp.data[0])
                throw err
            }
            return resp
        })
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "sendArticleLike",
                    url: url,
                    method: method,
                    data: JSON.stringify(data),
                    status: err.status,
                    response: err.responseJSON,
                }
            }
            const error = new Error('protectedApiCallWithPromise error')
            error.name = 'sendArticleLike fail'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}

export function sendBookLikedFeedback(bid, data){
    // data must be an array id topic ids
    const method = 'POST'
    const url = '/feedbacks/topics/books/'+bid+'/liked'
    return protectedApiCallWithPromise(method, url, data, true, false, '')
        .then(resp => {
            funnelUpdate("book_detailed_like_sent")
            return resp
        })
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "sendBookLikedFeedback",
                    url: url,
                    method: method,
                    data: JSON.stringify(data),
                    status: err.status,
                    response: err.responseJSON,
                }
            }
            const error = new Error('protectedApiCallWithPromise error')
            error.name = 'sendBookLikedFeedback fail'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}

export function sendBookDislikedFeedback(bid, data){
    // data must be an array id topic ids
    const method = 'POST'
    const url = '/feedbacks/topics/books/'+bid+'/disliked'
    return protectedApiCallWithPromise(method, url, data, true, false, '')
        .then(resp => {
            funnelUpdate("book_detailed_dislike_sent")
            return resp
        })
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "sendBookDislikedFeedback",
                    url: url,
                    method: method,
                    data: JSON.stringify(data),
                    status: err.status,
                    response: err.responseJSON,
                }
            }
            const error = new Error('protectedApiCallWithPromise error')
            error.name = 'sendBookDislikedFeedback fail'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}

export function sendArticleLikedFeedback(aid, data){
    // data must be an array id topic ids
    const method = 'POST'
    const url = '/feedbacks/topics/articles/'+aid+'/liked'
    return protectedApiCallWithPromise(method, url, data, true, false, '')
        .then(resp => {
            funnelUpdate("article_detailed_like_sent")
            return resp
        })
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "sendArticleLikedFeedback",
                    url: url,
                    method: method,
                    data: JSON.stringify(data),
                    status: err.status,
                    response: err.responseJSON,
                }
            }
            const error = new Error('protectedApiCallWithPromise error')
            error.name = 'sendArticleLikedFeedback fail'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}

export function sendArticleDislikedFeedback(aid, data){
    // data must be an array id topic ids
    const method = 'POST'
    const url = '/feedbacks/topics/articles/'+aid+'/disliked'
    return protectedApiCallWithPromise(method, url, data, true, false, '')
        .then(resp => {
            funnelUpdate("article_detailed_dislike_sent")
            return resp
        })
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "sendArticleDislikedFeedback",
                    url: url,
                    method: method,
                    data: JSON.stringify(data),
                    status: err.status,
                    response: err.responseJSON,
                }
            }
            const error = new Error('protectedApiCallWithPromise error')
            error.name = 'sendArticleDislikedFeedback fail'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}

export function podcastFollow(pid){
    const method = 'POST'
    const url = uam('/users/xxx/podcasts/'+pid)
    return protectedApiCallWithPromise(method, url, {}, false, false)
    .catch((err) => {
        const contextData = {
            apicalldata:{
                function: "setPodcastFollow",
                url: url,
                method: method,
                data: JSON.stringify(data),
                status: err.status,
                response: err.responseJSON,
            }
        }
        const error = new Error('protectedApiCallWithPromise error')
        error.name = 'setPodcastFollow fail'
        sentryAPIErrorV2(error, contextData)
    })
}

export function podcastUnfollow(pid){
    const method = 'DELETE'
    const url = uam('/users/xxx/podcasts/'+pid)
    return protectedApiCallWithPromise(method, url, {}, false, false)
    .catch((err) => {
        const contextData = {
            apicalldata:{
                function: "setPodcastUnfollow",
                url: url,
                method: method,
                data: JSON.stringify(data),
                status: err.status,
                response: err.responseJSON,
            }
        }
        const error = new Error('protectedApiCallWithPromise error')
        error.name = 'setPodcastUnfollow fail'
        sentryAPIErrorV2(error, contextData)
    })
}

// create a user on db, if user don't exist
export function sendMagnetData(email, IcAttrValue){
    const method = 'POST'
    const url = '/leads'
    const data = {'email': email, 'tag': IcAttrValue}
    return apiCallWithPromise(method, url, data)
    .catch((err) => {
        const contextData = {
            apicalldata:{
                function: "sendMagnetEmail",
                url: url,
                method: method,
                data: JSON.stringify(data),
                status: err.status,
                response: err.responseJSON,
            }
        }
        const error = new Error('apiCallWithPromise error')
        error.name = 'sendMagnetEmail fail'
        sentryAPIErrorV2(error, contextData)
        throw(err)
    })
}

export function isUserVerified(){
    if (!UIDg) {
        return Promise.reject(new Error('isUserVerified called without a logged-in user'))
    }
    const method = 'GET'
    const url = '/users/' + UIDg + '?preventCache=' + new Date()
    return protectedApiCallWithPromise(method, url, "", true, false)
        .then(resp => resp.user.user_verified)
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "isUserVerified",
                    url: url,
                    method: method,
                    status: err.status,
                    response: err.responseJSON,
                }
            }
            const error = new Error('protectedApiCallWithPromise error')
            error.name = 'isUserVerified fail'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}

export function getBooksByIds(ids){
    const method = 'POST'
    const url = '/searches/ids'
    const data = {ids: ids, categories: [], tags: [], progress: []}
    return protectedApiCallWithPromise(method, url, data, false, false)
        .then(resp => resp)
        .catch(err => {
            const contextData = {
                apicalldata:{
                    function: "getBooksByIds",
                    url: url,
                    method: method,
                    data: JSON.stringify(data),
                    status: err.status,
                    response: err.responseJSON,
                }
            }
            const error = new Error('protectedApiCallWithPromise error')
            error.name = 'getBooksByIds fail'
            sentryAPIErrorV2(error, contextData)
            throw(err)
        })
}